import { render } from "./ScrollPane.vue?vue&type=template&id=79ea6bf2&scoped=true"
import script from "./ScrollPane.vue?vue&type=script&lang=js"
export * from "./ScrollPane.vue?vue&type=script&lang=js"

import "./ScrollPane.vue?vue&type=style&index=0&id=79ea6bf2&lang=scss&scoped=true"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79ea6bf2"]])

export default __exports__